module.exports = __webpack_public_path__ + "static/media/avatar.5c1c7ccc.jpg";